import React, { useContext } from "react"
import styled from "styled-components"
import { Close } from "@styled-icons/evaicons-solid"
import SearchBar from "../SearchBar"
import StickyHeader from "../../../../context/stickyheaderContext"
import { kebabCase } from "../../../../utils/kebabCase"
import { Link } from "react-router-dom"

const FilterMainContainer = styled.div`
	border-bottom: solid 1px #efedeb;
	background-color: white;
	// z-index: 1000;
	height: 55px;
	width: 100%;
`

const Container = styled.div`
	max-width: 1120px;
	margin: auto;
	display: flex;
	height: 55px;
	justify-content: center;
`

const Filters = styled.div`
	display: flex;
	height: 54px;
	background-color: white;
`

const CategoryBtn = styled(Link)`
	background: none;
	border: none;
	color: #747474;
	cursor: pointer;
	font-family: Mallory;
	font-size: 14px;
	font-weight: 500;
	-webkit-letter-spacing: 0;
	-moz-letter-spacing: 0;
	-ms-letter-spacing: 0;
	letter-spacing: 0;
	line-height: 17px;
	text-align: center;
	margin-right: 32px;
	text-decoration: none;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	justify-content: center;

	&.active {
		border-bottom: solid 1px #000;
	}
`

const Flex = styled.div`
	display: flex;
`

const SearchContainer = styled.div`
	display: flex;
`
const CloseIcon = styled(Close)`
	font-family: Mallory;
	color: #747474;
	margin-bottom: 3px;
	cursor: pointer;
`

const CloseIconContainer = styled.span`
	padding-left: 3.5px;
	display: flex;
	justify-content: center;
	align-items: center;
`

const filterStickyStyle = {
	justifyContent: "center",
	position: "absolute",
	height: "54px",
	display: "flex",
	backgroundColor: "white",
	// 'top': '72px'
}

const filterContainerStyle = {}

export const MainContainer = (props) => {
	const stickyContext = useContext(StickyHeader)
	const { isStickyHeader } = stickyContext

	return (
		<FilterMainContainer style={isStickyHeader ? filterContainerStyle : null}>
			<Container>
				<Filters style={isStickyHeader ? filterStickyStyle : null}>
					<CategoryBtn
						to={`/blogs/all`}
						className={props.activeCategory == "all" ? "active-category" : ""}
						key={`all`}
						onClick={(e) => {
							props.clearFilter()
							props.handleClick(e, "all")
						}}
					>
						All
					</CategoryBtn>

					{props.items.map((category, i) => {
						return (
							<CategoryBtn
								to={`/blogs/all/tagged/${kebabCase(category.data.title[0].text)}`}
								className={
									props.activeCategory !== "all" &&
									props.activeCategory === kebabCase(category.data.title[0].text)
										? "active-category"
										: ""
								}
								key={`${category.data.title[0]}-${i}}`}
								onClick={(e) => {
									props.handleClick(e, category.data.title[0].text)
								}}
							>
								{category.data.title[0].text}
							</CategoryBtn>
						)
					})}
				</Filters>
				{!isStickyHeader ? (
					<>
						<SearchBar
							isSearched={props.isSearched}
							handleInputChange={props.handleInputChange}
							searchValue={props.searchValue}
						></SearchBar>
						<CloseIconContainer>
							{!props.isSearched == "" ? (
								<CloseIcon
									size="18"
									onClick={() => {
										props.clearFilter()
										props.resetSearch()
									}}
								/>
							) : (
								<></>
							)}
						</CloseIconContainer>
					</>
				) : (
					<></>
				)}
			</Container>
		</FilterMainContainer>
	)
}
